/* Carga de archivo:   elemento que carga un archivo a la vez */

//*react- recursos

//*componentes-utiles
import GeneraDropzone from "../../../componentes/generaDropZone/GeneraDropzone";

//*clases
//import "../../../componentes/generaDropZone/dropzone.css";

//*datos

//*archivos (imagenes y elementos necesarios para la rutina)

//*api's (servicios y store)

//*store's

//*componente
export default function Ejemplo() {
  //*api store

  //*store's

  //*data

  //*constantes y variables

  //*usestate

  //*useEffect

  //*funciones

  //*vista
  return (
    <div  className="container container-Vista" >
      <h1>Ejemplo de Dropzone:</h1>
      <div className="container-Componente" >
        <br/>
        <GeneraDropzone />
        <br/>
      </div>
      <br />
    </div>
  );
}
